import { render, staticRenderFns } from "./PreList.vue?vue&type=template&id=1794117a&scoped=true"
import script from "./PreList.vue?vue&type=script&lang=js"
export * from "./PreList.vue?vue&type=script&lang=js"
import style0 from "./PreList.vue?vue&type=style&index=0&id=1794117a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1794117a",
  null
  
)

export default component.exports